import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { PwaInstallService } from './pwa-install.service';

@Component({
  selector: 'app-pwa-ios-install-banner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, MatButtonModule],
  template: `
    <div class="fixed bottom-0 inset-x-0 z-50 bg-pmdf-surface
                border-t border-pmdf-border-subtle shadow-pmdf-card p-4
                pb-[env(safe-area-inset-bottom,16px)]">

      <button class="absolute top-2 right-2"
              mat-icon-button
              (click)="fechar()">
        <mat-icon class="icon-sm">close</mat-icon>
      </button>

      <div class="flex items-start gap-3">
        <img src="/img/logo/pmdf.svg" alt="PMDF" class="h-12 w-12 shrink-0" />

        <div>
          <p class="text-sm font-semibold text-pmdf-primary m-0">
            Instalar Nexus PMDF
          </p>
          <p class="text-xs text-pmdf-muted-55 mt-1 m-0">
            Para instalar, toque em
            <mat-icon class="icon-xs align-middle">ios_share</mat-icon>
            <strong>Compartilhar</strong> e depois em
            <strong>"Adicionar à Tela de Início"</strong>.
          </p>
        </div>
      </div>

      <div class="mt-3 flex justify-center">
        <div class="flex items-center gap-6 text-xs text-pmdf-muted-55">
          <div class="flex flex-col items-center gap-1">
            <div class="h-10 w-10 rounded-pmdf-card bg-pmdf-primary/10
                        flex items-center justify-center">
              <mat-icon class="icon-base text-pmdf-primary">ios_share</mat-icon>
            </div>
            <span>1. Compartilhar</span>
          </div>
          <mat-icon class="icon-sm text-pmdf-muted-55">arrow_forward</mat-icon>
          <div class="flex flex-col items-center gap-1">
            <div class="h-10 w-10 rounded-pmdf-card bg-pmdf-primary/10
                        flex items-center justify-center">
              <mat-icon class="icon-base text-pmdf-primary">add_box</mat-icon>
            </div>
            <span>2. Tela de Início</span>
          </div>
        </div>
      </div>
    </div>
  `,
})
export class PwaIosInstallBanner {
  private readonly pwaInstallService = inject(PwaInstallService);

  fechar(): void {
    this.pwaInstallService.dismissInstallDialog();
  }
}
